import { TronWeb } from 'tronweb';
export var NetworkType;
(function (NetworkType) {
    NetworkType["Mainnet"] = "Mainnet";
    NetworkType["Shasta"] = "Shasta";
    NetworkType["Nile"] = "Nile";
    /**
     * When use custom node
     */
    NetworkType["Unknown"] = "Unknown";
})(NetworkType || (NetworkType = {}));
export var ChainNetwork;
(function (ChainNetwork) {
    ChainNetwork["Mainnet"] = "Mainnet";
    ChainNetwork["Shasta"] = "Shasta";
    ChainNetwork["Nile"] = "Nile";
})(ChainNetwork || (ChainNetwork = {}));
export { TronWeb };
//# sourceMappingURL=types.js.map